
// export const DATE_FORMAT = process.env.REACT_APP_DATE_FORMAT || 'MM/DD/YYYY';


  const customDateFormat = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

 export const customDateFormatShort = (date) => { 
  const d = new Date(date);

  const month = d.toLocaleString('en-US', { month: 'short' }); // Jul
  const year = d.toLocaleString('en-US', { year: '2-digit' }); // 26
  const day = d.toLocaleString('en-US', { day: '2-digit' });   // 11

  return `${month} ${year}, ${day}`;
};

export default {
customDateFormatShort,
};